import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export class StockFishResponse {
  success: boolean;
  evaluation: number;
  mate: boolean;
  bestmove: string;
  continuation: string;
}

export enum GameState {
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  PAUSED = 'PAUSED',
  ENDED = 'ENDED'
}


export class Game {
  status: string = GameState.PENDING;
  result: string;
  active: string = 'white';
  timer: number = 5;
  player: string = 'white';
  opponent: string = 'black';
  whiteTimer: number = 60 * 5;
  blackTimer: number = 60 * 5;
  eval: number = 50;
  score: number;
  engine: number = 10;
}
export class BestMoveParams {
  fen: string;
  searchMoves: string[];
  wtime: number | null;
  btime: number | null;
  winc: number | null;
  binc: number | null;
  movestogo: number | null;
  depth: number | null;
  nodes: number | null;
  mate: number | null;
  movetime: number | null;
}
export class BestMove{
  move: string;
  evaluation: number;
  continuation: string;
}


@Injectable({
  providedIn: 'root'
})
export class StockfishService {
  private readonly endpointURL: string = environment.server;

  constructor(private client: HttpClient) { }

  getBestMover(params: BestMoveParams) {
    const URL = this.endpointURL + 'chess/best-move';
    return lastValueFrom(this.client.post<BestMove>(URL, params));
  }

  getEval(params: BestMoveParams) {
    const URL = this.endpointURL + 'chess/eval';
    return lastValueFrom(this.client.post<BestMove>(URL, params));
  }
  
  


  private buildHttpParams(paramsObj: { [key: string]: any }): HttpParams {
    let params = new HttpParams();

    Object.entries(paramsObj).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        params = params.set(key, value.toString());
      }
    });

    return params;
  }


}
